import config from '@/modules/live-messages/config';

const dataTableHeader = () => config.dataTableHeader;

const dataTitle = state => () => {
  if (state.messageThatIsBeingEdited.data === undefined
    || state.messageThatIsBeingEdited.dataTitle !== undefined) {
    return state.messageThatIsBeingEdited.dataTitle;
  }
  return state.messageThatIsBeingEdited.data.title;
};

const dataAuthor = state => () => {
  if (state.messageThatIsBeingEdited.data === undefined
    || state.messageThatIsBeingEdited.dataAuthor !== undefined) {
    return state.messageThatIsBeingEdited.dataAuthor;
  }
  return state.messageThatIsBeingEdited.data.creatorStaffId.description;
};

const liveType = state => state.live.type || 'live';

export default {
  dataTableHeader,
  dataTitle,
  dataAuthor,
  liveType,
};
